


















import { Component, Vue, PropSync, Watch, Prop } from "vue-property-decorator";
import { PrestadorResumidoModel } from "@/models/cadastros/saude/PrestadorResumidoModel";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";

@Component({
  inheritAttrs: false,
})
export default class AtendimentoAutocomplete extends Vue {
  @PropSync("atendimento", { required: true })
  atendimentoSynced!: PrestadorResumidoModel | undefined;

  @Prop({default: -1})
  readonly idAtendimento!: number;

  atendimentos: any[] = [];
  loading = false;
  numAtendimento = "";

  // Utilizado para o debounce manual
  timerAtendimento: any = 0;

  @Watch("numAtendimento")
  obterAtendimentos(val: string) {
    val = (val || "").trim();
    if (val == "") {
      this.atendimentos = [];
      return;
    }

    // se o campo tem menos que 5 caracteres não faz a busca
    if (val.length < 4) return;
    this.loading = true;

    // Debounce manual - LODASH não funcionou
    clearTimeout(this.timerAtendimento);
    this.timerAtendimento = setTimeout(() => {
      saudeAtendimentoService.pesquisar({numeroAtendimento: `${val}%`}, {itemsPerPage: 0}, '', '', 'F', true)
        .then((atendimentos: any) => {
          console.log(atendimentos);
        //   this.prestadoresLocalizados = atendimentos;
        })
        .catch((err) => console.error(err))
        .finally(() => this.loading = false);
    }, 300);
  }

  get autoCompleteAttrs() {
    const { rules, name, ...attrs } = this.$attrs;
    return attrs;
  }

  get validationAttrs() {
    const { rules, name, ...attrs } = this.$attrs;
    return {
      rules,
      name,
    };
  }
}
